'use client';

import React from 'react';
import * as LucideIcons from 'react-icons/lu';

type LucideIconName = keyof typeof LucideIcons;

export interface IconProps extends Omit<React.ComponentPropsWithoutRef<'svg'>, 'ref'> {
  name: LucideIconName;
  title?: string;
  size?: number | string;
}

export function Icon({ name, className, size = 16, title, ...rest }: IconProps) {
  const IconComponent = LucideIcons[name];
  if (!IconComponent) {
    throw new Error(`[Icon] Unknown lucide icon "${name}".`);
  }

  return (
    <IconComponent
      className={className}
      size={size}
      aria-hidden={title ? undefined : true}
      focusable='false'
      title={title}
      {...rest}
    />
  );
}
